import axios from "../axios-config";

// Get artist tracklist (track / album / playlist)
export const fetchTrackList = async ({ type }) => {
    const res = await axios.get("/user/v1/get-artist-track", {
        params: { type },
    });
    return res.data?.data || [];
};

//Search artist tracks
export const searchArtistTracks = async ({
    artistTrackType,
    query,
    artistName,
    artistId,
}) => {
    let type = artistTrackType;

    // detect spotify url
    const spotifyUrlRegex =
        /(?:open\.spotify\.com\/|spotify:)(track|album|playlist)[/:]([a-zA-Z0-9]+)/;

    const match = query.match(spotifyUrlRegex);
    if (match) {
        type = match[1];
    }

    const res = await axios.get("/user/v1/search-artist-track", {
        params: { type, query, artistName, artistId },
    });

    return {
        type,
        list: res.data?.data || [],
    };
};

// Get album / playlist tracks
export const fetchAlbumPlaylistTracks = async ({ id, type }) => {
    const res = await axios.get("/user/v1/get-playlist-album-tracks", {
        params: { id, type },
    });

    return res.data?.data || { items: [], pagination: {} };
};